import ProfileSection from './ProfileSection';
import RecommendationSection from './RecommendationSection';
import MiddleProfileSection from './MiddleProfileSection';

export {ProfileSection, RecommendationSection, MiddleProfileSection};
